import { Clear } from "@material-ui/icons";
import Cookies from "js-cookie";
import React from "react";
import { useState } from "react";
import config from "../../config/apiConfig";
import { Comments, mapToComments } from "../../hoc/withComments";
import { getInfo } from "../../utils/hooks";
import "./CommentEditor.scss";

type Props = {
    comments: Comments[];
    onDelete: (id: string) => Promise<void>;
    onAdd: (comment: string) => Promise<[string, string]>;
    onCancel: () => void;
    leftPointer: number;
};

const CommentEditor: React.FC<Props> = (props) => {
    const [text, setText] = useState("");
    const [comments, setComments] = useState<Comments[]>(props.comments);
    const [loading, setLoading] = useState(false);

    const loadComments = (storyId: string, chapterId: string) => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        return fetch(
            config.BASE_URL +
                "/v1/get/showmilers/story/" +
                storyId +
                "/chapter/" +
                chapterId +
                "/comments/all",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) => {
                const comments = (res.data as any[]).map((d) =>
                    mapToComments(d)
                );
                const chComments = comments.filter(
                    (c) => c.comment_type === "chapter_comment"
                );
                chComments.sort(
                    (a, b) => a.created_at.getTime() - b.created_at.getTime()
                );
                setComments(chComments);
            });
    };

    const addComment = async () => {
        const comment = text;
        setText("");
        const [storyId, chapterId] = await props.onAdd(comment);
        setLoading(true);
        loadComments(storyId, chapterId).finally(() => setLoading(false));
    };

    return (
        <div className="comment__editor">
            {comments.length === 0 ? (
                <React.Fragment>
                    <div className="part comment__editor__head">
                        <div className="userpic"></div>
                        <div className="username">{getInfo()?.name ?? "User"}</div>
                    </div>
                    <div className="part">
                        <textarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            placeholder="Add comment"
                            disabled={loading}
                        />
                    </div>
                    <div className="part comment__editor__actions">
                        <button
                            style={{ color: "#969696" }}
                            onClick={props.onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            style={{ color: "#005aff" }}
                            onClick={addComment}
                            disabled={loading}
                        >
                            Comment
                        </button>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Clear
                        style={{
                            width: 16,
                            position: "absolute",
                            top: 4,
                            right: 12,
                            fill: "#ccc",
                            cursor: "pointer",
                        }}
                        onClick={() => props.onCancel()}
                    />
                    {comments.map((comment) => (
                        <React.Fragment key={comment.id}>
                            <div className="part comment__editor__head">
                                <div className="userpic"></div>
                                <div className="username">
                                    {comment.user_name}
                                </div>
                            </div>
                            <p>{comment.comment}</p>
                            <div className="devider" />
                        </React.Fragment>
                    ))}
                    <div className="part">
                        <textarea
                            className="input"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            placeholder="Add another comment"
                            disabled={loading}
                        />
                    </div>
                    <div className="part comment__editor__actions">
                        <button
                            style={{ color: "#969696" }}
                            onClick={props.onCancel}
                        >
                            Cancel
                        </button>
                        <button
                            style={{ color: "#005aff" }}
                            onClick={addComment}
                            disabled={loading}
                        >
                            Comment
                        </button>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

export default CommentEditor;
